/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.racehorse360
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/racehorse360/facility_service.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var stronachgroup_first_racehorse360_messages_pb = require("../../../stronachgroup/first/racehorse360/messages_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.racehorse360 = require("./facility_service_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.FacilityServiceClient =
  function FacilityServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.FacilityServicePromiseClient =
  function FacilityServicePromiseClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListBarnsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListBarnsResponse>}
 */
const methodDescriptor_FacilityService_ListBarns =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.FacilityService/ListBarns",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListBarnsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListBarnsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListBarnsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListBarnsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListBarnsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListBarnsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListBarnsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.FacilityServiceClient.prototype.listBarns =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityService/ListBarns",
      request,
      metadata || {},
      methodDescriptor_FacilityService_ListBarns,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListBarnsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListBarnsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.FacilityServicePromiseClient.prototype.listBarns =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityService/ListBarns",
      request,
      metadata || {},
      methodDescriptor_FacilityService_ListBarns
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetBarnRequest,
 *   !proto.stronachgroup.first.racehorse360.Barn>}
 */
const methodDescriptor_FacilityService_GetBarn = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.FacilityService/GetBarn",
  grpc.web.MethodType.UNARY,
  stronachgroup_first_racehorse360_messages_pb.GetBarnRequest,
  stronachgroup_first_racehorse360_messages_pb.Barn,
  /**
   * @param {!proto.stronachgroup.first.racehorse360.GetBarnRequest} request
   * @return {!Uint8Array}
   */
  function (request) {
    return request.constructor.encode(request).finish();
  },
  stronachgroup_first_racehorse360_messages_pb.Barn.decode
);

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetBarnRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Barn)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Barn>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.FacilityServiceClient.prototype.getBarn =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityService/GetBarn",
      request,
      metadata || {},
      methodDescriptor_FacilityService_GetBarn,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetBarnRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Barn>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.FacilityServicePromiseClient.prototype.getBarn =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityService/GetBarn",
      request,
      metadata || {},
      methodDescriptor_FacilityService_GetBarn
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetFacilityRequest,
 *   !proto.stronachgroup.first.racehorse360.Facility>}
 */
const methodDescriptor_FacilityService_GetFacility =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.FacilityService/GetFacility",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.GetFacilityRequest,
    stronachgroup_first_racehorse360_messages_pb.Facility,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.GetFacilityRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Facility.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetFacilityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Facility)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Facility>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.FacilityServiceClient.prototype.getFacility =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityService/GetFacility",
      request,
      metadata || {},
      methodDescriptor_FacilityService_GetFacility,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetFacilityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Facility>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.FacilityServicePromiseClient.prototype.getFacility =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityService/GetFacility",
      request,
      metadata || {},
      methodDescriptor_FacilityService_GetFacility
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListFacilitiesRequest,
 *   !proto.stronachgroup.first.racehorse360.ListFacilitiesResponse>}
 */
const methodDescriptor_FacilityService_ListFacilities =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.FacilityService/ListFacilities",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListFacilitiesRequest,
    stronachgroup_first_racehorse360_messages_pb.ListFacilitiesResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListFacilitiesRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListFacilitiesResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListFacilitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListFacilitiesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListFacilitiesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.FacilityServiceClient.prototype.listFacilities =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityService/ListFacilities",
      request,
      metadata || {},
      methodDescriptor_FacilityService_ListFacilities,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListFacilitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListFacilitiesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.FacilityServicePromiseClient.prototype.listFacilities =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityService/ListFacilities",
      request,
      metadata || {},
      methodDescriptor_FacilityService_ListFacilities
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.EditFacilityInfoRequest,
 *   !proto.stronachgroup.first.racehorse360.Facility>}
 */
const methodDescriptor_FacilityService_EditFacilityInfo =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.FacilityService/EditFacilityInfo",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.EditFacilityInfoRequest,
    stronachgroup_first_racehorse360_messages_pb.Facility,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.EditFacilityInfoRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Facility.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.EditFacilityInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Facility)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Facility>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.FacilityServiceClient.prototype.editFacilityInfo =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityService/EditFacilityInfo",
      request,
      metadata || {},
      methodDescriptor_FacilityService_EditFacilityInfo,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.EditFacilityInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Facility>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.FacilityServicePromiseClient.prototype.editFacilityInfo =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityService/EditFacilityInfo",
      request,
      metadata || {},
      methodDescriptor_FacilityService_EditFacilityInfo
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListCoursesRequest,
 *   !proto.stronachgroup.first.racehorse360.ListCoursesResponse>}
 */
const methodDescriptor_FacilityService_ListCourses =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.FacilityService/ListCourses",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListCoursesRequest,
    stronachgroup_first_racehorse360_messages_pb.ListCoursesResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListCoursesRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListCoursesResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListCoursesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListCoursesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListCoursesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.FacilityServiceClient.prototype.listCourses =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityService/ListCourses",
      request,
      metadata || {},
      methodDescriptor_FacilityService_ListCourses,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListCoursesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListCoursesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.FacilityServicePromiseClient.prototype.listCourses =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityService/ListCourses",
      request,
      metadata || {},
      methodDescriptor_FacilityService_ListCourses
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest,
 *   !proto.stronachgroup.first.racehorse360.Course>}
 */
const methodDescriptor_FacilityService_EditCurrentTrackCondition =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.FacilityService/EditCurrentTrackCondition",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.EditCurrentTrackConditionRequest,
    stronachgroup_first_racehorse360_messages_pb.Course,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Course.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Course)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Course>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.FacilityServiceClient.prototype.editCurrentTrackCondition =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityService/EditCurrentTrackCondition",
      request,
      metadata || {},
      methodDescriptor_FacilityService_EditCurrentTrackCondition,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Course>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.FacilityServicePromiseClient.prototype.editCurrentTrackCondition =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityService/EditCurrentTrackCondition",
      request,
      metadata || {},
      methodDescriptor_FacilityService_EditCurrentTrackCondition
    );
  };

module.exports = proto.stronachgroup.first.racehorse360;
